import { Injectable } from '@angular/core';
import { PetSpeciesFilterableType, PetStatus } from 'src/app/interfaces/pet';
import { ProductType, User } from 'src/app/interfaces/user';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root',
})
export class MemberShipOptionsService {
  constructor(private userService: UserService) {}

  identiBasePlusAvailable(user: User): boolean {
    return (
      !user || (user && this.userService.isUserBasic(user.originalProductType))
    );
  }

  identiFindAvailable(user: User): boolean {
    return (
      !user ||
      (user &&
        (this.userService.isUserBasicOrBasicPlus(user.originalProductType) ||
          user.ultimate !== true))
    );
  }

  identiAlertAvailable(user: User): boolean {
    return (
      !user ||
      (user &&
        this.userService.isUserBasicOrBasicPlus(user.originalProductType)) ||
      user.productType !== ProductType.Premium
    );
  }

  doesUserHaveMembership(user: User): boolean {
    return user.originalProductType !== ProductType.Basic || user.ultimate;
  }

  getUserMembershipName(user: User): string {
    if (user.ultimate) return 'identifind';

    switch (user.originalProductType) {
      case ProductType.Basic:
        return 'identibase';

      case ProductType.BasicPlus:
        return 'identibase+';

      case ProductType.LegacyPlus:
        return 'plus';

      case ProductType.LegacyPremium:
        return 'premium';

      case ProductType.Premium:
        return 'identialert';

      default:
        return 'identibase';
    }
  }

  private doesTheUserHaveOnlyCats(user: User): boolean {
    const doesTheUserHaveCat = !!user.pets.find(
      (pet) => pet.speciesFilter === PetSpeciesFilterableType.Cat && pet.status !== PetStatus.Deceased
    );
    const doesTheUserHaveDog = !!user.pets.find(
      (pet) => pet.speciesFilter === PetSpeciesFilterableType.Dog && pet.status !== PetStatus.Deceased
    );

    return doesTheUserHaveCat && !doesTheUserHaveDog;
  }
}
